import { render, staticRenderFns } from "./schedule-block.vue?vue&type=template&id=233f7a28"
import script from "./schedule-block.vue?vue&type=script&lang=js"
export * from "./schedule-block.vue?vue&type=script&lang=js"
import style0 from "./schedule-block.vue?vue&type=style&index=0&id=233f7a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzButton: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/button/index.js').default,RzSelect: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/select/index.vue').default,RzDateCalendarInput: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/date-calendar-input/index.vue').default,RzSimpleTable: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/simple-table/index.vue').default,RzPreloader: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/preloader/index.vue').default,RzTabs: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/tabs/index.vue').default})
